<template>
  <ZLoader v-if="flagLoading"></ZLoader>
  <div
    v-else
    class="w-full h-screen flex flex-col items-center justify-center bg-brand-gradient overflow-hidden relative"
  >
    <!-- Fondo desenfocado -->
    <div class="absolute inset-0 flex justify-center items-center">
      <div
        class="absolute w-[569px] h-[585px] bg-accent-500/40 rounded-full blur-[400px]"
        style="z-index: 1"
      ></div>
      <div
        class="absolute w-[351px] h-[361px] bg-accent-400/40 rounded-full blur-[300px]"
        style="z-index: 1"
      ></div>
    </div>

    <!-- Imagen Logo -->
    <img
      class="w-[200px] h-[105px] z-10 rounded-lg bg-white/95 p-2 shadow-lg"
      src="/teopm.png"
      style="margin-top: 2rem"
    />

    <!-- Tarjeta de contenido -->
    <div
      class="relative bg-white h-auto rounded-xl shadow border-t-4 border-accent-500 py-10 px-6 gap-5 w-[448px] h-[370px] flex flex-col items-center z-20"
      style="margin-top: 1rem"
    >
      <div
        class="text-brand-900 text-2xl font-bold font-['Public Sans'] leading-[34px] text-center"
      >
        Forgot Password
      </div>
      <div
        class="w-full text-center text-[#3c4452] text-sm font-normal font-['Public Sans'] leading-snug"
      >
        {{
          isOtpStep
            ? "Enter the OTP we sent to your email"
            : isNewPasswordStep
            ? "Enter the new password"
            : 'Confirm your email and we will send you an OTP, if you recive an OTP via support please click "I already have an OTP" button after putting your email.'
        }}
      </div>

      <div class="w-full flex flex-col justify-center items-center gap-5 mt-5">
        <!-- Email Input -->
        <div
          v-if="!isOtpStep && !isNewPasswordStep"
          class="w-full flex flex-col gap-1.5"
        >
          <label
            class="text-[#4d586c] text-base font-medium font-['Public Sans'] leading-relaxed"
          >
            Email
            <input
              v-model="email"
              type="email"
              placeholder="mail@example.com"
              :class="{
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-red-400 border-solid':
                  !isEmailValid(email),
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid':
                  isEmailValid(email),
              }"
            />
          </label>
        </div>
        <button
          @click="toggleOTP"
          :disabled="!isEmailValid(email)"
          v-if="!isOtpStep && !isNewPasswordStep"
          :class="{
            'px-3.5 py-[9px] bg-brand-200 rounded-lg shadow justify-center items-center gap-2 flex':
              !isEmailValid(email),
            'px-3.5 py-[9px] bg-accent-gradient hover:brightness-105 rounded-lg shadow justify-center items-center gap-2 flex':
              isEmailValid(email),
          }"
        >
          <div class="text-white text-base font-semibold ] leading-normal">
            I already have an OTP
          </div>
        </button>

        <!-- OTP Input -->
        <div v-if="isOtpStep" class="w-full flex flex-col gap-1.5">
          <label
            class="text-[#4d586c] text-base font-medium font-['Public Sans'] leading-relaxed"
          >
            OTP
            <input
              v-model="otp"
              type="text"
              placeholder="Enter OTP"
              maxlength="4"
              :class="{
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-red-400 border-solid':
                  !isOtpValid(otp),
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid':
                  isOtpValid(otp),
              }"
            />
          </label>
        </div>

        <div v-if="isNewPasswordStep" class="w-full flex flex-col gap-1.5">
          <div class="relative w-full">
            <label
              class="text-slate-600 text-base font-medium font-['Public Sans'] leading-relaxed"
            >
              Password
            </label>
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="********"
              :class="{
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-red-400 border-solid':
                  !isPasswordValid(password),
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid':
                  isPasswordValid(password),
              }"
              class="pr-10"
            />
            <button
              type="button"
              @click="toggleShowPassword"
              class="absolute right-3 top-2/3 transform -translate-y-1/2 text-brand-600 hover:text-brand-700 text-sm"
            >
              {{ showPassword ? "Hide" : "Show" }}
            </button>
          </div>

          <div class="text-xs text-red-500 mt-2">
            <ul>
              <li :class="{ 'text-green-500': isPasswordLongEnough }">
                Minimum 6 characters
              </li>
              <li :class="{ 'text-green-500': hasUpperCaseLetter }">
                At least one uppercase letter
              </li>
              <li :class="{ 'text-green-500': hasSpecialCharacter }">
                At least one special character
              </li>
            </ul>
          </div>

          <div class="relative w-full">
            <label
              class="text-slate-600 text-base font-medium font-['Public Sans'] leading-relaxed"
            >
              Confirm Password
            </label>
            <input
              v-model="confirmPassword"
              :type="showConfirmPassword ? 'text' : 'password'"
              placeholder="********"
              :class="{
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-red-400 border-solid':
                  !confirmPassword || confirmPassword !== password,
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid':
                  confirmPassword === password,
              }"
              class="pr-10"
            />
            <button
              type="button"
              @click="toggleShowConfirmPassword"
              class="absolute right-3 top-2/3 transform -translate-y-1/2 text-brand-600 hover:text-brand-700 text-sm"
            >
              {{ showConfirmPassword ? "Hide" : "Show" }}
            </button>
          </div>
          <button
            @click="newPassword"
            :disabled="!isPasswordValid(password)"
            class="px-3.5 py-[9px] bg-accent-gradient hover:brightness-105 rounded-lg shadow justify-center items-center gap-2 flex"
          >
            <div class="text-white text-base font-semibold ] leading-normal">
              Confirm password
            </div>
          </button>
        </div>

        <div class="w-full flex flex-col gap-3" v-else>
          <button
            v-if="!isOtpStep && !isNewPasswordStep"
            @click="sendOtp"
            :disabled="!isEmailValid(email)"
            :class="{
              'px-3.5 py-[9px] bg-brand-200 rounded-lg shadow justify-center items-center gap-2 flex':
                !isEmailValid(email),
              'px-3.5 py-[9px] bg-accent-gradient hover:brightness-105 rounded-lg shadow justify-center items-center gap-2 flex':
                isEmailValid(email),
            }"
          >
            <div class="text-white text-base font-semibold leading-normal">
              Next
            </div>
          </button>
          <button
            v-if="isOtpStep"
            @click="verifyOtp"
            :disabled="!isOtpValid(otp)"
            class="px-3.5 py-[9px] bg-accent-gradient hover:brightness-105 rounded-lg shadow justify-center items-center gap-2 flex"
          >
            <div class="text-white text-base font-semibold leading-normal">
              Verify OTP
            </div>
          </button>

          <button
            @click="cancel"
            class="w-full px-[18px] py-2.5 bg-white rounded-lg shadow border border-[#dfe3f0] text-center"
          >
            <div
              class="text-[#4d586c] text-base font-semibold ] leading-normal"
            >
              Cancel
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ZLoader from "./MainLoader.vue";

export default {
  components: { ZLoader },
  setup() {
    const store = useStore();
    const router = useRouter();
    const email = ref("");
    const otp = ref("");
    const flagLoading = ref(false);
    const isOtpStep = ref(false);
    const isNewPasswordStep = ref(false);
    const password = ref("");
    const confirmPassword = ref("");
    const showPassword = ref(false);
    const showConfirmPassword = ref(false);

    const isEmailValid = (email) => /\S+@\S+\.\S+/.test(email);
    const isOtpValid = (otp) => otp.length === 4;
    const isPasswordValid = (password) => {
      const minLength = 6;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
      return (
        password.length >= minLength &&
        hasUpperCase &&
        hasSpecialChar &&
        confirmPassword.value === password
      );
    };

    const isPasswordLongEnough = computed(() => password.value.length >= 6);
    const hasUpperCaseLetter = computed(() => /[A-Z]/.test(password.value));
    const hasSpecialCharacter = computed(() =>
      /[!@#$%^&*(),.?":{}|<>]/.test(password.value)
    );

    async function sendOtp() {
      flagLoading.value = true;
      try {
        const data = { email: email.value };
        await store.dispatch("forgotPassword", data);
        isOtpStep.value = true;
      } catch (error) {
        console.error("Error sending OTP:", error);
      } finally {
        flagLoading.value = false;
      }
    }

    async function verifyOtp() {
      flagLoading.value = true;
      try {
        const data = { email: email.value, otp: otp.value };
        const otpVerified = await store.dispatch("verifyOtp", data);
        if (otpVerified.data.res) {
          isOtpStep.value = false;
          isNewPasswordStep.value = true;
        } else {
          store.commit("setSnackbar", {
            text: otpVerified.data.message,
            enabled: true,
          });
        }
      } catch (error) {
        console.error("Error verifying OTP:", error);
      } finally {
        flagLoading.value = false;
      }
    }

    const toggleShowPassword = () => {
      showPassword.value = !showPassword.value;
    };

    const toggleShowConfirmPassword = () => {
      showConfirmPassword.value = !showConfirmPassword.value;
    };

    async function newPassword() {
      flagLoading.value = true;
      try {
        const data = { email: email.value, password: password.value };
        await store.dispatch("setNewPassword", data);
        router.push({ name: "Login" });
      } catch (error) {
        console.error("Error updating password:", error);
      } finally {
        flagLoading.value = false;
      }
    }
    function cancel() {
      email.value = "";
      otp.value = "";
      router.push({ name: "Login" });
    }

    function toggleOTP() {
      isOtpStep.value = true;
    }

    return {
      email,
      otp,
      isEmailValid,
      isOtpValid,
      sendOtp,
      verifyOtp,
      flagLoading,
      isOtpStep,
      isNewPasswordStep,
      isPasswordValid,
      password,
      confirmPassword,
      newPassword,
      cancel,
      toggleShowPassword,
      showPassword,
      toggleShowConfirmPassword,
      showConfirmPassword,
      isPasswordLongEnough,
      hasUpperCaseLetter,
      hasSpecialCharacter,
      toggleOTP,
    };
  },
};
</script>
  